export const configData =  {  

    APP_URL: "/basic/web/api/",
    DOMAIN_URL: "/basic/web/",
    DRUPAL_APP_URL: "https://www.sportsmanagementworldwide.com/api/",
    DRUPAL_DOMAIN_URL: "https://www.sportsmanagementworldwide.com",
    AGENCY_DOMAIN_URL: "https://www.smwwagency.com",
    SCOUT_DOMAIN_URL: "https://www.smwwscout.com",
    GOOGLE_RECAPTCHA_SITE_KEY: '6LeGtQoTAAAAAC7f3LyY82WLCfOH66NMbs9f6eNv',
    DOMAIN_PUBLIC_URL: `${window.location.protocol}//${window.location.hostname}`
     }